export type Language = 'en' | 'de';

export const translations = {
  en: {
    "Lock types": "Lock Types",
    "Lock properties": "Lock Properties",
    "Supplier Icon": "Supplier Icon",
    "Database preview": "Database Preview",
    "Backups": "Backups",
    "Tax change": "Tax Change",
    "Database update": "Database Update",
    "Users": "Users",
    "Menu": "Menu",
    "Logout": "Logout",
    "Zarządzanie Użytkownikami": "User Management",
    "Dodaj użytkownika": "Add User",
    "Anuluj": "Cancel",
    "Użytkownicy": "Users",
    "Role i Uprawnienia": "Roles & Permissions",
    "Login": "Username",
    "Hasło": "Password",
    "Zapisz": "Save",
    "Nie udało się pobrać użytkowników": "Failed to fetch users",
    "Nie udało się dodać użytkownika": "Failed to add user",
    "Nie udało się usunąć użytkownika": "Failed to delete user",
    "Nie udało się pobrać ról": "Failed to fetch roles",
    "Nie udało się zaktualizować uprawnień": "Failed to update permissions",
    "Czy na pewno usunąć użytkownika": "Are you sure you want to delete user",
    "Nie można usunąć głównego konta admina": "Cannot delete main admin account",
    "Ładowanie...": "Loading...",
    "Rola": "Role",
    "Uprawnienia": "Permissions",
    "Użytkownik": "User",
    "Data utworzenia": "Creation Date",
    "Akcje": "Actions",
    "Usuń": "Delete",
    "Pobierz": "Download",
    "Brak uprawnień do tego widoku": "No permission for this view",
    "Choose view from the menu": "Choose view from the menu",
    "Backup created successfully!": "Backup created successfully!",
    "Failed to create backup": "Failed to create backup",
    "Are you sure you want to restore this backup? All current data will be overwritten!": "Are you sure you want to restore this backup? All current data will be overwritten!",
    "Database successfully restored!": "Database successfully restored!",
    "Failed to restore backup": "Failed to restore backup",
    "Are you sure you want to delete this backup?": "Are you sure you want to delete this backup?",
    "Backup deleted successfully!": "Backup deleted successfully!",
    "Failed to delete backup": "Failed to delete backup",
    "Failed to download backup": "Failed to download backup",
    "Create, restore, and manage database backups": "Create, restore, and manage database backups",
    "Creating...": "Creating...",
    "Backup SQLite": "Backup SQLite",
    "Backup PostgreSQL": "Backup PostgreSQL",
    "No backups found. Create your first backup using the buttons above.": "No backups found. Create your first backup using the buttons above.",
    "Size": "Size",
    "Created by": "Created by",
    "Selected": "Selected",
    "Restoring...": "Restoring...",
    "/backups": "/backups",
    "Failed to load backups": "Failed to load backups",
    "a": "a",
    "Please select a backup from the list to restore.": "Please select a backup from the list to restore.",
    "Restore Selected Backup": "Restore Selected Backup",
    "/database/tables": "/database/tables",
    "Failed to load database tables": "Failed to load database tables",
    "Failed to load table data": "Failed to load table data",
    "Cannot edit row: missing first-column primary value": "Cannot edit row: missing first-column primary value",
    "Failed to update cell": "Failed to update cell",
    "Cannot delete row: missing primary identifier": "Cannot delete row: missing primary identifier",
    "Are you sure you want to delete this row?": "Are you sure you want to delete this row?",
    "Failed to delete row": "Failed to delete row",
    "PERMANENTLY DELETE ALL DATA from table": "PERMANENTLY DELETE ALL DATA from table",
    "This cannot be undone.": "This cannot be undone.",
    "Failed to clear table": "Failed to clear table",
    "Failed to export CSV. Make sure you are logged in.": "Failed to export CSV. Make sure you are logged in.",
    "Failed to save row": "Failed to save row",
    "Loading table data...": "Loading table data...",
    "No data available in this table": "No data available in this table",
    "Actions": "Actions",
    "Edit": "Edit",
    "Double-click to edit": "Double-click to edit",
    "Save": "Save",
    "Cancel": "Cancel",
    "Delete row": "Delete row",
    "Delete": "Delete",
    "Prev": "Prev",
    "Showing": "Showing",
    "of": "of",
    "Next": "Next",
    "rows on this page — total": "rows on this page — total",
    "Export to CSV": "Export to CSV",
    "Clear Table": "Clear Table",
    "Database Preview & Edit": "Database Preview & Edit",
    "View and edit database tables. Double-click any cell to edit its value.": "View and edit database tables. Double-click any cell to edit its value.",
    "Analyzing file": "Analyzing file",
    "File analyzed successfully.": "File analyzed successfully.",
    "rows found.": "rows found.",
    "Failed to upload CSV file": "Failed to upload CSV file",
    "Separator changed. Please re-upload the file to see updated preview.": "Separator changed. Please re-upload the file to see updated preview.",
    "Please select a table and upload a CSV file first.": "Please select a table and upload a CSV file first.",
    "Please map at least one column before importing.": "Please map at least one column before importing.",
    "Are you sure you want to import": "Are you sure you want to import",
    "rows into table": "rows into table",
    "Importing data...": "Importing data...",
    "Successfully imported": "Successfully imported",
    "rows!": "rows!",
    "Failed to import CSV data": "Failed to import CSV data",
    "Database Import from CSV": "Database Import from CSV",
    "Import and update database tables from CSV files with column mapping.": "Import and update database tables from CSV files with column mapping.",
    "Processing...": "Processing...",
    "Upload CSV": "Upload CSV",
    "Target Table": "Target Table",
    "CSV Separator": "CSV Separator",
    "Comma (,)": "Comma (,)",
    "Semicolon (;)": "Semicolon (;)",
    "Tab": "Tab",
    "Pipe (|)": "Pipe (|)",
    "Upsert Match Column (Optional)": "Upsert Match Column (Optional)",
    "If selected, existing records with matching value in this column will be updated instead of inserted.": "If selected, existing records with matching value in this column will be updated instead of inserted.",
    "-- No Match (Always Insert) --": "-- No Match (Always Insert) --",
    "Column Mapping": "Column Mapping",
    "Map CSV columns to database columns": "Map CSV columns to database columns",
    "-- Skip Column --": "-- Skip Column --",
    "Current Data (top). New values appear in the panel below.": "Current Data (top). New values appear in the panel below.",
    "Hide new values panel": "Hide new values panel",
    "Show new values panel": "Show new values panel",
    "New Values (CSV) — differences highlighted": "New Values (CSV) — differences highlighted",
    "Importing...": "Importing...",
    "Import": "Import",
    "Rows": "Rows",
    "/database/tables/${tableName}/columns": "/database/tables/${tableName}/columns",
    "/supplier-icons/suppliers": "/supplier-icons/suppliers",
    "Failed to load suppliers": "Failed to load suppliers",
    "/supplier-icons/icons": "/supplier-icons/icons",
    "Failed to save icon": "Failed to save icon",
    "Failed to upload icon": "Failed to upload icon",
    "Are you sure you want to delete this supplier icon?": "Are you sure you want to delete this supplier icon?",
    "Failed to delete icon": "Failed to delete icon",
    "Loading suppliers...": "Loading suppliers...",
    "Supplier Icons": "Supplier Icons",
    "Assign icons to each supplier": "Assign icons to each supplier",
    "Select icon...": "Select icon...",
    "No icon": "No icon",
    "Change Icon": "Change Icon",
    "Add Icon": "Add Icon",
    "Delete Icon": "Delete Icon",
    "/lock-properties": "/lock-properties",
    "Failed to load lock properties": "Failed to load lock properties",
    "/lock-properties/icons": "/lock-properties/icons",
    "/system-options/available-columns": "/system-options/available-columns",
    "Are you sure you want to delete the icon": "Are you sure you want to delete the icon",
    "Cannot delete icon. It is still used by:": "Cannot delete icon. It is still used by:",
    "Maximum": "Maximum",
    "active properties allowed!": "active properties allowed!",
    "Failed to save property": "Failed to save property",
    "New Property": "New Property",
    "Failed to add lock property": "Failed to add lock property",
    "Are you sure you want to delete this property?": "Are you sure you want to delete this property?",
    "Failed to delete lock property": "Failed to delete lock property",
    "Loading...": "Loading...",
    "Lock Properties Management": "Lock Properties Management",
    "Active properties:": "Active properties:",
    "(displayed on page 2)": "(displayed on page 2)",
    "Add Property": "Add Property",
    "Name:": "Name:",
    "Property name": "Property name",
    "Property Code:": "Property Code:",
    "-- Select Property Code --": "-- Select Property Code --",
    "Unique identifier for this property": "Unique identifier for this property",
    "Description:": "Description:",
    "Description shown to users": "Description shown to users",
    "Icon:": "Icon:",
    "-- Select Icon --": "-- Select Icon --",
    "Uploading...": "Uploading...",
    "Upload New": "Upload New",
    "Available Icons:": "Available Icons:",
    "Icon preview": "Icon preview",
    "Code:": "Code:",
    "Active": "Active",
    "Inactive": "Inactive",
    "Icon uploaded successfully!": "Icon uploaded successfully!",
    "Icon \"${iconName}\" deleted successfully": "Icon \"${iconName}\" deleted successfully",
    "${t(\"Cannot delete icon. It is still used by:\")} ${err.response.data.usedBy.join(', ')}": "${t(\"Cannot delete icon. It is still used by:\")} ${err.response.data.usedBy.join(', ')}",
    "${t(\"Maximum\")} ${MAX_ACTIVE} ${t(\"active properties allowed!\")}": "${t(\"Maximum\")} ${MAX_ACTIVE} ${t(\"active properties allowed!\")}",
    "/lock-types/available": "/lock-types/available",
    "/lock-types": "/lock-types",
    "Failed to load lock types": "Failed to load lock types",
    "/lock-types/icons": "/lock-types/icons",
    "Icon uploaded successfully": "Icon uploaded successfully",
    "Icon": "Icon",
    "deleted successfully": "deleted successfully",
    "Failed to add lock type": "Failed to add lock type",
    "Error": "Error",
    "Are you sure you want to delete this lock type?": "Are you sure you want to delete this lock type?",
    "Failed to delete lock type": "Failed to delete lock type",
    "Changes saved successfully!": "Changes saved successfully!",
    "Failed to save lock types": "Failed to save lock types",
    "Error: Failed to save lock types": "Error: Failed to save lock types",
    "Lock Types Management": "Lock Types Management",
    "Available Types from Database (click to add):": "Available Types from Database (click to add):",
    "No lock types configured yet. Add types from the list above.": "No lock types configured yet. Add types from the list above.",
    "Type Code (from database):": "Type Code (from database):",
    "Display Name:": "Display Name:",
    "Display name (e.g., Doppelzylinder)": "Display name (e.g., Doppelzylinder)",
    "/": "/",
    "${t(\"Icon uploaded successfully\")}: ${response.data.name}": "${t(\"Icon uploaded successfully\")}: ${response.data.name}",
    "${t(\"Icon\")} \"${iconName}\" ${t(\"deleted successfully\")}": "${t(\"Icon\")} \"${iconName}\" ${t(\"deleted successfully\")}",
    "Lock type ${typeCode} added successfully!": "Lock type ${typeCode} added successfully!",
    "${t(\"Error\")}: ${errorMsg}": "${t(\"Error\")}: ${errorMsg}",
    "/suppliers": "/suppliers",
    "Failed to save supplier": "Failed to save supplier",
    "New Supplier": "New Supplier",
    "Failed to add supplier": "Failed to add supplier",
    "Are you sure you want to delete this supplier?": "Are you sure you want to delete this supplier?",
    "Failed to delete supplier": "Failed to delete supplier",
    "Supplier Management": "Supplier Management",
    "Active suppliers:": "Active suppliers:",
    "(displayed on pages 2, 3, and 4)": "(displayed on pages 2, 3, and 4)",
    "Add Supplier": "Add Supplier",
    "Supplier name": "Supplier name",
    "Configuration saved successfully!": "Configuration saved successfully!",
    "Failed to save configuration": "Failed to save configuration",
    "System Options Mapping": "System Options Mapping",
    "Configure which lock properties are enabled for each system": "Configure which lock properties are enabled for each system",
    "Systems": "Systems",
    "Save Configuration": "Save Configuration",
    "Enabled": "Enabled",
    "Disabled": "Disabled",
    "Select a system from the list to configure its options": "Select a system from the list to configure its options",
    "/system-options": "/system-options",
    "Failed to load current tax rate": "Failed to load current tax rate",
    "Please enter a valid number.": "Please enter a valid number.",
    "Tax rate must be between 0 and 100.": "Tax rate must be between 0 and 100.",
    "New rate is the same as current rate.": "New rate is the same as current rate.",
    "Are you sure you want to change the tax rate from": "Are you sure you want to change the tax rate from",
    "to": "to",
    "Tax rate successfully updated to": "Tax rate successfully updated to",
    "Failed to update tax rate": "Failed to update tax rate",
    "Loading tax rate...": "Loading tax rate...",
    "Tax Rate Management": "Tax Rate Management",
    "Manage the global VAT/tax rate applied in the configurator.": "Manage the global VAT/tax rate applied in the configurator.",
    "Current Tax Rate": "Current Tax Rate",
    "New Tax Rate (%)": "New Tax Rate (%)",
    "e.g. 23": "e.g. 23",
    "Updating...": "Updating...",
    "Update Tax Rate": "Update Tax Rate",
    "/tax-rate": "/tax-rate",
    "/users": "/users",
    "/roles": "/roles"
},
  de: {
    "Lock types": " Zylindertyp",
    "Lock properties": " Schlosseigenschaften",
    "Supplier Icon": " Lieferanten-Icon",
    "Database preview": " Datenbank-Vorschau",
    "Backups": " Sicherungen",
    "Tax change": " Steueränderung",
    "Database update": " Datenbank-Update",
    "Users": " Benutzer",
    "Menu": "Menü",
    "Logout": "Abmelden",
    "Zarządzanie Użytkownikami": "Benutzerverwaltung",
    "Dodaj użytkownika": "Anwender hinzufügen",
    "Anuluj": "Abbrechen",
    "Użytkownicy": "Anwender",
    "Role i Uprawnienia": "Rollen & Berechtigungen",
    "Login": "Benutzername",
    "Hasło": "Passwort",
    "Zapisz": "Speichern",
    "Nie udało się pobrać użytkowników": "Fehler beim Abrufen der Benutzer",
    "Nie udało się dodać użytkownika": "Fehler beim Hinzufügen des Benutzers",
    "Nie udało się usunąć użytkownika": "Fehler beim Löschen des Benutzers",
    "Nie udało się pobrać ról": "Fehler beim Abrufen der Rollen",
    "Nie udało się zaktualizować uprawnień": "Fehler beim Aktualisieren der Berechtigungen",
    "Czy na pewno usunąć użytkownika": "Sind Sie sicher, dass Sie den Benutzer löschen möchten",
    "Nie można usunąć głównego konta admina": "Das Haupt-Admin-Konto kann nicht gelöscht werden",
    "Ładowanie...": "Wird geladen...",
    "Rola": "Rolle",
    "Uprawnienia": "Berechtigungen",
    "Użytkownik": "Benutzer",
    "Data utworzenia": "Erstellungsdatum",
    "Akcje": "Aktionen",
    "Usuń": "Löschen",
    "Pobierz": "Herunterladen",
    "Brak uprawnień do tego widoku": "Keine Berechtigung für diese Ansicht",
    "Choose view from the menu": "Wählen Sie eine Ansicht aus dem Menü",
    "Backup created successfully!": "Backup erfolgreich erstellt!",
    "Failed to create backup": "Backup konnte nicht erstellt werden",
    "Are you sure you want to restore this backup? All current data will be overwritten!": "Sind Sie sicher, dass Sie dieses Backup wiederherstellen möchten? Alle aktuellen Daten werden überschrieben!",
    "Database successfully restored!": "Datenbank erfolgreich wiederhergestellt!",
    "Failed to restore backup": "Fehler beim Wiederherstellen des Backups",
    "Are you sure you want to delete this backup?": "Sind Sie sicher, dass Sie dieses Backup löschen möchten?",
    "Backup deleted successfully!": "Backup erfolgreich gelöscht!",
    "Failed to delete backup": "Fehler beim Löschen des Backups",
    "Failed to download backup": "Fehler beim Herunterladen des Backups",
    "Create, restore, and manage database backups": "Erstellen, wiederherstellen und verwalten von Datenbank-Backups",
    "Creating...": "Wird erstellt...",
    "Backup SQLite": "SQLite sichern",
    "Backup PostgreSQL": "PostgreSQL sichern",
    "No backups found. Create your first backup using the buttons above.": "Keine Backups gefunden. Erstellen Sie Ihr erstes Backup mit den Schaltflächen oben.",
    "Size": "Größe",
    "Created by": "Erstellt von",
    "Selected": "Ausgewählt",
    "Restoring...": "Wiederherstellen...",
    "/backups": "/backups",
    "Failed to load backups": "Backups konnten nicht geladen werden",
    "a": "a",
    "Please select a backup from the list to restore.": "Bitte wählen Sie ein Backup aus der Liste zum Wiederherstellen aus.",
    "Restore Selected Backup": "Ausgewähltes Backup wiederherstellen",
    "/database/tables": "/database/tables",
    "Failed to load database tables": "Fehler beim Laden der Datenbanktabellen",
    "Failed to load table data": "Fehler beim Laden der Tabellendaten",
    "Cannot edit row: missing first-column primary value": "Zeile kann nicht bearbeitet werden: primärer Wert der ersten Spalte fehlt",
    "Failed to update cell": "Zelle konnte nicht aktualisiert werden",
    "Cannot delete row: missing primary identifier": "Zeile kann nicht gelöscht werden: fehlende primäre Kennung",
    "Are you sure you want to delete this row?": "Sind Sie sicher, dass Sie diese Zeile löschen möchten?",
    "Failed to delete row": "Fehler beim Löschen der Zeile",
    "PERMANENTLY DELETE ALL DATA from table": "DAUERHAFT ALLE DATEN LÖSCHEN aus der Tabelle",
    "This cannot be undone.": "Dies kann nicht rückgängig gemacht werden.",
    "Failed to clear table": "Fehler beim Leeren der Tabelle",
    "Failed to export CSV. Make sure you are logged in.": "CSV-Export fehlgeschlagen. Melden Sie sich an.",
    "Failed to save row": "Fehler beim Speichern der Zeile",
    "Loading table data...": "Tabellendaten werden geladen...",
    "No data available in this table": "Keine Daten in dieser Tabelle verfügbar",
    "Actions": "Aktionen",
    "Edit": "Bearbeiten",
    "Double-click to edit": "Doppelklick zum Bearbeiten",
    "Save": "Speichern",
    "Cancel": "Abbrechen",
    "Delete row": "Zeile löschen",
    "Delete": "Löschen",
    "Prev": "Zurück",
    "Showing": "Zeige",
    "of": "von",
    "Next": "Weiter",
    "rows on this page — total": "Zeilen auf dieser Seite — gesamt",
    "Export to CSV": "Als CSV exportieren",
    "Clear Table": "Tabelle leeren",
    "Database Preview & Edit": "Datenbank-Vorschau & Bearbeitung",
    "View and edit database tables. Double-click any cell to edit its value.": "Datenbanktabellen anzeigen und bearbeiten. Doppelklick auf eine Zelle, um ihren Wert zu bearbeiten.",
    "Analyzing file": "Datei wird analysiert",
    "File analyzed successfully.": "Datei erfolgreich analysiert.",
    "rows found.": "Zeilen gefunden.",
    "Failed to upload CSV file": "Fehler beim Hochladen der CSV-Datei",
    "Separator changed. Please re-upload the file to see updated preview.": "Trennzeichen geändert. Bitte laden Sie die Datei erneut hoch",
    "Please select a table and upload a CSV file first.": "Bitte wählen Sie eine Tabelle aus und laden Sie zuerst eine CSV-Datei hoch.",
    "Please map at least one column before importing.": "Bitte ordnen Sie vor dem Import mindestens eine Spalte zu.",
    "Are you sure you want to import": "Möchten Sie wirklich importieren",
    "rows into table": "Zeilen in Tabelle",
    "Importing data...": "Daten werden importiert...",
    "Successfully imported": "Erfolgreich importiert",
    "rows!": "Zeilen!",
    "Failed to import CSV data": "Fehler beim Importieren der CSV-Daten",
    "Database Import from CSV": "Datenbank-Import aus CSV",
    "Import and update database tables from CSV files with column mapping.": "Tabellen aus CSV-Dateien importieren und aktualisieren mit Spaltenzuordnung.",
    "Processing...": "Verarbeitung...",
    "Upload CSV": "CSV hochladen",
    "Target Table": "Zieltabelle",
    "CSV Separator": "CSV-Trennzeichen",
    "Comma (,)": "Komma (,)",
    "Semicolon (;)": "Semikolon (;)",
    "Tab": "Tabulator",
    "Pipe (|)": "Pipe (|)",
    "Upsert Match Column (Optional)": "Upsert-Übereinstimmungsspalte (Optional)",
    "If selected, existing records with matching value in this column will be updated instead of inserted.": "Wenn ausgewählt, werden vorhandene Datensätze mit übereinstimmendem Wert aktualisiert anstatt eingefügt.",
    "-- No Match (Always Insert) --": "-- Keine Übereinstimmung (Immer einfügen) --",
    "Column Mapping": "Spaltenzuordnung",
    "Map CSV columns to database columns": "CSV-Spalten Datenbankspalten zuordnen",
    "-- Skip Column --": "-- Spalte überspringen --",
    "Current Data (top). New values appear in the panel below.": "Aktuelle Daten (oben). Neue Werte (unten).",
    "Hide new values panel": "Panel mit neuen Werten ausblenden",
    "Show new values panel": "Panel mit neuen Werten anzeigen",
    "New Values (CSV) — differences highlighted": "Neue Werte (CSV) — Unterschiede",
    "Importing...": "Wird importiert...",
    "Import": "Importieren",
    "Rows": "Zeilen",
    "/database/tables/${tableName}/columns": "/database/tables/${tableName}/columns",
    "/supplier-icons/suppliers": "/supplier-icons/suppliers",
    "Failed to load suppliers": "Fehler beim Laden von Lieferanten",
    "/supplier-icons/icons": "/supplier-icons/icons",
    "Failed to save icon": "Fehler beim Speichern des Icons",
    "Failed to upload icon": "Fehler beim Hochladen des Icons",
    "Are you sure you want to delete this supplier icon?": "Möchten Sie dieses Lieferanten-Icon wirklich löschen?",
    "Failed to delete icon": "Fehler beim Löschen des Icons",
    "Loading suppliers...": "Lieferanten werden geladen...",
    "Supplier Icons": "Lieferanten-Icons",
    "Assign icons to each supplier": "Jedem Lieferanten ein Icon zuordnen",
    "Select icon...": "Icon auswählen...",
    "No icon": "Kein Icon",
    "Change Icon": "Icon ändern",
    "Add Icon": "Icon hinzufügen",
    "Delete Icon": "Icon löschen",
    "/lock-properties": "/lock-properties",
    "Failed to load lock properties": "Fehler beim Laden von Schlosseigenschaften",
    "/lock-properties/icons": "/lock-properties/icons",
    "/system-options/available-columns": "/system-options/available-columns",
    "Are you sure you want to delete the icon": "Sind Sie sicher, dass Sie das Icon löschen möchten",
    "Cannot delete icon. It is still used by:": "Icon kann nicht gelöscht werden. Es wird noch verwendet von:",
    "Maximum": "Maximal",
    "active properties allowed!": "aktive Eigenschaften erlaubt!",
    "Failed to save property": "Eigenschaft konnte nicht gespeichert werden",
    "New Property": "Neue Eigenschaft",
    "Failed to add lock property": "Fehler beim Hinzufügen der Schlosseigenschaft",
    "Are you sure you want to delete this property?": "Möchten Sie diese Eigenschaft wirklich löschen?",
    "Failed to delete lock property": "Fehler beim Löschen der Schlosseigenschaft",
    "Loading...": "Wird geladen...",
    "Lock Properties Management": "Schlosseigenschaften Verwaltung",
    "Active properties:": "Aktive Eigenschaften:",
    "(displayed on page 2)": "(auf Seite 2 angezeigt)",
    "Add Property": "Eigenschaft hinzufügen",
    "Name:": "Name:",
    "Property name": "Name der Eigenschaft",
    "Property Code:": "Eigenschaftscode:",
    "-- Select Property Code --": "-- Eigenschaftscode auswählen --",
    "Unique identifier for this property": "Eindeutige Kennung für diese Eigenschaft",
    "Description:": "Beschreibung:",
    "Description shown to users": "Beschreibung für Benutzer sichtbar",
    "Icon:": "Icon:",
    "-- Select Icon --": "-- Icon auswählen --",
    "Uploading...": "Wird hochgeladen...",
    "Upload New": "Neu hochladen",
    "Available Icons:": "Verfügbare Icons:",
    "Icon preview": "Icon-Vorschau",
    "Code:": "Code:",
    "Active": "Aktiv",
    "Inactive": "Inaktiv",
    "Icon uploaded successfully!": "Icon erfolgreich hochgeladen!",
    "Icon \"${iconName}\" deleted successfully": "Icon \"${iconName}\" deleted successfully",
    "${t(\"Cannot delete icon. It is still used by:\")} ${err.response.data.usedBy.join(', ')}": "${t(\"Cannot delete icon. It is still used by:\")} ${err.response.data.usedBy.join(', ')}",
    "${t(\"Maximum\")} ${MAX_ACTIVE} ${t(\"active properties allowed!\")}": "${t(\"Maximum\")} ${MAX_ACTIVE} ${t(\"active properties allowed!\")}",
    "/lock-types/available": "/lock-types/available",
    "/lock-types": "/lock-types",
    "Failed to load lock types": "Fehler beim Laden von Schlosstypen",
    "/lock-types/icons": "/lock-types/icons",
    "Icon uploaded successfully": "Icon erfolgreich hochgeladen",
    "Icon": "Icon",
    "deleted successfully": "erfolgreich gelöscht",
    "Failed to add lock type": "Fehler beim Hinzufügen des Zylindertyp",
    "Error": "Fehler",
    "Are you sure you want to delete this lock type?": "Sind Sie sicher, dass Sie diesen Zylindertyp löschen möchten?",
    "Failed to delete lock type": "Fehler beim Löschen des Zylindertyp",
    "Changes saved successfully!": "Änderungen erfolgreich gespeichert!",
    "Failed to save lock types": "Fehler beim Speichern von Schlosstypen",
    "Error: Failed to save lock types": "Fehler: Schlosstypen konnten nicht gespeichert werden",
    "Lock Types Management": "Zylindertyp",
    "Available Types from Database (click to add):": "Verfügbare Typen aus der Datenbank (zum Hinzufügen klicken):",
    "No lock types configured yet. Add types from the list above.": "Noch keine Zylindertyp konfiguriert",
    "Type Code (from database):": "Typcode (aus Datenbank):",
    "Display Name:": "Anzeigename:",
    "Display name (e.g., Doppelzylinder)": "Anzeigename (z.B., Doppelzylinder)",
    "/": "/",
    "${t(\"Icon uploaded successfully\")}: ${response.data.name}": "${t(\"Icon uploaded successfully\")}: ${response.data.name}",
    "${t(\"Icon\")} \"${iconName}\" ${t(\"deleted successfully\")}": "${t(\"Icon\")} \"${iconName}\" ${t(\"deleted successfully\")}",
    "Lock type ${typeCode} added successfully!": "Lock type ${typeCode} added successfully!",
    "${t(\"Error\")}: ${errorMsg}": "${t(\"Error\")}: ${errorMsg}",
    "/suppliers": "/suppliers",
    "Failed to save supplier": "Lieferanten speichern fehlgeschlagen",
    "New Supplier": "Neuer Lieferant",
    "Failed to add supplier": "Lieferanten hinzufügen fehlgeschlagen",
    "Are you sure you want to delete this supplier?": "Sind Sie sicher, dass Sie diesen Lieferanten löschen möchten?",
    "Failed to delete supplier": "Lieferanten löschen fehlgeschlagen",
    "Supplier Management": "Lieferantenverwaltung",
    "Active suppliers:": "Aktive Lieferanten:",
    "(displayed on pages 2, 3, and 4)": "(auf den Seiten 2, 3 und 4 angezeigt)",
    "Add Supplier": "Lieferanten hinzufügen",
    "Supplier name": "Name des Lieferanten",
    "Configuration saved successfully!": "Konfiguration erfolgreich gespeichert!",
    "Failed to save configuration": "Konfiguration speichern fehlgeschlagen",
    "System Options Mapping": "Systemoptionen Zuordnung",
    "Configure which lock properties are enabled for each system": "Konfigurieren Sie, welche Schlosseigenschaften für jedes System aktiviert sind",
    "Systems": "Systeme",
    "Save Configuration": "Konfiguration speichern",
    "Enabled": "Aktiviert",
    "Disabled": "Deaktiviert",
    "Select a system from the list to configure its options": "Wählen Sie ein System aus der Liste, um dessen Optionen zu konfigurieren",
    "/system-options": "/system-options",
    "Failed to load current tax rate": "Fehler beim Laden des aktuellen Steuersatzes",
    "Please enter a valid number.": "Bitte geben Sie eine gültige Zahl ein.",
    "Tax rate must be between 0 and 100.": "Der Steuersatz muss zwischen 0 und 100 liegen.",
    "New rate is the same as current rate.": "Der neue Satz entspricht dem aktuellen Satz.",
    "Are you sure you want to change the tax rate from": "Möchten Sie den Steuersatz wirklich ändern von",
    "to": "auf",
    "Tax rate successfully updated to": "Steuersatz erfolgreich aktualisiert auf",
    "Failed to update tax rate": "Fehler beim Aktualisieren des Steuersatzes",
    "Loading tax rate...": "Steuersatz wird geladen...",
    "Tax Rate Management": "Steuersatz Verwaltung",
    "Manage the global VAT/tax rate applied in the configurator.": "Verwalten Sie den globalen MwSt./Steuersatz, der im Konfigurator angewendet wird.",
    "Current Tax Rate": "Aktueller Steuersatz",
    "New Tax Rate (%)": "Neuer Steuersatz (%)",
    "e.g. 23": "z.B. 19",
    "Updating...": "Wird aktualisiert...",
    "Update Tax Rate": "Steuersatz aktualisieren",
    "/tax-rate": "/tax-rate",
    "/users": "/users",
    "/roles": "/roles"
  }
};

export type TranslationKey = keyof typeof translations.en;
